// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Configuration";
import "@keller/App/Libraries";
import "@keller/App/Store/Reducers";
import "@keller/XDL";

// For production, include a set of commonly used widgets in the main bundle
// the rest will be split into their own chunks
// Do not do this for the ./Overrides folder

// XNG-Changes: We have an issue with chunks (v5.1.2205.802), we'll open a ticket for insite to fix it,
// but now we'll stop it and make the code load on main bundle
const widgets = require.context("./App/Widgets", true, /\.tsx$/);

// enable hot module reloading for widgets
const onHotWidgetReplace = addWidgetsFromContext(widgets);
if (module.hot) {
    module.hot.accept(widgets.id.toString(), () =>
        onHotWidgetReplace(require.context("./App/Widgets", true, /\.tsx$/)),
    );
}

// Load all custom pages so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
const pages = require.context("./App/Pages", true, /\.tsx$/);
const onHotPageReplace = addPagesFromContext(pages);
if (module.hot) {
    module.hot.accept(pages.id.toString(), () => onHotPageReplace(require.context("./App/Pages", true, /\.tsx$/)));
}

// Load all handlers so they are included in the bundle.
const handlers = require.context("./App/Handlers", true);
handlers.keys().forEach(key => handlers(key));

// in production, the widget extensions are included in the chunks created for widgets
// if (!IS_PRODUCTION) {
// load all widget extensions. They could be loaded individually instead
const widgetExtensions = require.context("./App/WidgetExtensions", true);
widgetExtensions.keys().forEach(key => widgetExtensions(key));

// load all widget extensions. They could be loaded individually instead
const componentExtensions = require.context("./App/ComponentExtensions", true);
componentExtensions.keys().forEach(key => componentExtensions(key));

// load all widget extensions. They could be loaded individually instead
const pagesExtensions = require.context("./App/PagesExtensions", true);
pagesExtensions.keys().forEach(key => pagesExtensions(key));
